
        import Swiper from 'swiper/bundle';
        window.Swiper = Swiper;
        import 'bootstrap';
        import 'C:/laragon/www/urgentcare/wp-content/themes/preferredurgentcare_v2/assets/js/fa-setup.js';
        import 'C:/laragon/www/urgentcare/wp-content/themes/preferredurgentcare_v2/assets/js/main.js';
        import 'C:/laragon/www/urgentcare/wp-content/themes/preferredurgentcare_v2/assets/js/swiper-init.js';
    